<template>
  <div v-if="visible" class="greeting-card-mask">
    <div class="greeting-card-container">
      <img :src="cardImage" class="greeting-card-img" alt="贺卡" />
      <div class="greeting-card-content">
        <div class="greeting-text" v-if="blessing" v-html="blessing"></div>
      </div>
      <div class="greeting-card-button" @click="handleButtonClick">
        {{ needSignature ? '签名收下' : '开心收下' }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GreetingCard',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    cardImage: {
      type: String,
      default: ''
    },
    blessing: {
      type: String,
      default: ''
    },
    needSignature: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleButtonClick() {
      this.$emit('button-click');
    }
  }
};
</script>

<style scoped>
/* 贺卡弹窗样式 */
.greeting-card-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.greeting-card-container {
  position: relative;
  width: 80%;
  max-width: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.greeting-card-img {
  width: 100%;
  height: auto;
  display: block;
}

.greeting-card-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.greeting-text {
  width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.greeting-text ::v-deep * {
  margin: 0;
  padding: 0;
}

.greeting-card-button {
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  max-width: 200px;
  height: 2.5rem;
  line-height: 2.5rem;
  background: linear-gradient(180deg, #d32f2f 0%, #f44336 100%);
  border-radius: 1.25rem;
  text-align: center;
  color: #ffffff;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(211, 47, 47, 0.3);
  transition: all 0.3s ease;
}

.greeting-card-button:active {
  transform: translateX(-50%) scale(0.98);
  box-shadow: 0 1px 4px rgba(211, 47, 47, 0.2);
}
</style>

